import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";

import { setModeIframe } from "./mods/iframe/redux/actions/index";
import { setAuth } from "../../../../actions/index";

function MainRoute() {
  const dispatch = useDispatch();

  return (
    <Switch>
      <Route path="/view/:mode" render={ props => {
        dispatch(setModeIframe(props.match.params.mode));
        return <Redirect to="/home" />
      }} />
      <Route exact path={[`/`, '/home']} render={ props => {
        if (props.location.search.includes('?code=')) { 
          const code = props.location.search.replace('?code=', '')
          dispatch(setModeIframe('play'));
          dispatch(setAuth({ code }));
        }
      } } />
    </Switch>
  );
}

export default MainRoute;
